import {Pipe, PipeTransform} from '@angular/core';

export const ORDER_STATE_TEXT: Record<string, string> = {
  ArrangingPayment: '待付款',
  PaymentAuthorized: '付款授权',
  PaymentSettled: '等待发货',
  PartiallyShipped: '部分发货',
  Shipped: '已发货',
  PartiallyDelivered: '部分收货',
  Delivered: '已完成',
  Modifying: '订单修改',
  ArrangingAdditionalPayment: '安排额外付款',
  ConfirmReceiptOfGoods: '用户确认收货',
  ReviewSettled: '评价完成',
  Cancelled: '交易关闭',
};

@Pipe({
  name: 'orderState',
})
export class OrderStatePipe implements PipeTransform {
  transform(value: string): string {
    return ORDER_STATE_TEXT[value] || value;
  }
}
